module.exports = __webpack_public_path__ + "static/img/trial2.5c633d72.svg";